import { lazyLoadView } from '@utils/LazyLoad'
import { FEATURES, SEARCH_GROUPS } from '@constants/Text'

export default [
  {
    path: '/bi',
    name: 'bi',
    // redirect: '/financeiro/geral',
    meta: {
      can_show: FEATURES.BI_CUSTOMIZED,
      search: {
        title: 'BI (legado)',
        description: 'Relatórios e dashboards do BI personalizado',
        keywords: ['bi', 'relatórios', 'dashboards', 'indicadores', 'power bi'],
        icon: 'graph-pie',
        group: SEARCH_GROUPS.ANALISES,
      },
    },
    component: () =>
      lazyLoadView(
        import('@src/modules/power-bi/views/bi-nav-bar/view-bi-nav-bar')
      ),
    children: [
      {
        path: 'dash/:title',
        name: 'bi.dash',
        meta: {
          can_show: FEATURES.BI_CUSTOMIZED,
        },
        component: () =>
          lazyLoadView(
            import('@src/modules/power-bi/views/bi-dashboard/view-bi-dashboard')
          ),
      },
    ],
  },
  {
    path: '/bi-embed',
    name: 'embed',
    redirect: '/bi-embed/home',
    meta: {
      can_show: FEATURES.BI_EMBED,
      search: {
        title: 'BI Externo',
        description: 'Relatórios de BI incorporados de fontes externas',
        keywords: [
          'bi externo',
          'embed',
          'relatórios',
          'power bi',
          'integração',
        ],
        icon: 'mdi-chart-box-plus-outline',
        group: SEARCH_GROUPS.ANALISES,
      },
    },
    component: () =>
      lazyLoadView(
        import(
          '@src/modules/power-bi/views/embed-nav-bar/view-embed-nav-bar.vue'
        )
      ),

    children: [
      {
        path: 'home',
        name: 'embed.home',
        component: () =>
          lazyLoadView(
            import('@src/modules/power-bi/views/embed/view-embed.vue')
          ),
      },
      {
        path: 'gerenciar',
        name: 'embed.manager',
        meta: {
          search: {
            title: 'Gerenciar BI Externo',
            description: 'Configurar relatórios de BI externo incorporados',
            keywords: [
              'bi externo',
              'embed',
              'gerenciar',
              'configurar',
              'relatórios',
            ],
            group: SEARCH_GROUPS.ANALISES,
          },
        },
        component: () =>
          lazyLoadView(
            import(
              '@src/modules/power-bi/views/manager-bi-embed/view-manager-bi-embed.vue'
            )
          ),
      },
    ],
  },
]
